import { computed, defineComponent, ref, watch } from 'vue';
import SAvatarStemdoer from '@/components/stemdo-components/s-avatar-stemdoer/SAvatarStemdoer.vue';
import { useI18N } from '@/plugins/i18n';
import SPagination from '@/components/stemdo-components/s-pagination/SPagination.vue';
import SSkeletonTable from '@/components/stemdo-components/s-skeleton-table/SSkeletonTable.vue';
import { LabelStyles } from '@/components/stemdo-components/s-label/sLabel';
import SLabel from '@/components/stemdo-components/s-label/SLabel.vue';
import { Project } from '@/shared/model/project.model';
import { useRouter } from '@/plugins/router';

export default defineComponent({
  props: {
    projects: {
      type: Array,
      required: true
    },
    displaySkeleton: {
      type: Boolean,
      default: true
    },
    companies: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  components: {
    SAvatarStemdoer,
    SPagination,
    SSkeletonTable,
    SLabel
  },
  setup(props) {
    const i18n = useI18N();
    const router = useRouter();
    const ITEMS_PER_PAGE = 12;
    const offset = ref(0);

    watch(
      () => props.projects,
      () => {
        offset.value = 0;
      }
    );

    const getCompanyName = (id: string) => {
      let items = props.companies as Array<{ id: string; desc: string }>;
      if (items && typeof (items as any).value !== 'undefined') {
        items = (items as any).value;
      }
      const found = items?.find(c => c.id === id);
      return found ? found.desc : 'N/D';
    };

    const projectsInPage = computed(() => {
      const start = offset.value * ITEMS_PER_PAGE;
      const end = start + ITEMS_PER_PAGE;
      return props.projects.slice(start, end);
    });

    const headers = computed(() => [
      { text: i18n.t('projects-filter-list.table.name'), value: 'name', width: '29%' },
      { text: i18n.t('projects-filter-list.table.initDate'), value: 'initDate', width: '25%' },
      { text: i18n.t('projects-filter-list.table.stemdoers'), value: 'members', width: '16%' },
      { text: i18n.t('projects-filter-list.table.company'), value: 'companyCif', width: '24%' },
      { text: i18n.t('projects-filter-list.table.odooId'), value: 'odooId' }
    ]);

    const getMembers = (members: any[] = []) => {
      return Array.isArray(members) ? members.filter(m => m && m !== '').length : 0;
    };

    const onPageChange = (newPage: number) => {
      offset.value = newPage - 1;
    };

    const onRowClick = (project: Project) => {
      //TODO: When developing the project details page, change the route name.
      // router.push({ name: '', params: { id: project.id.toString() } });
    };

    return {
      headers,
      projectsInPage,
      ITEMS_PER_PAGE,
      getMembers,
      onPageChange,
      onRowClick,
      getCompanyName
    };
  }
});
